import { createFileRoute } from '@tanstack/react-router';

import { EvidenceInboxView } from '../../features/inbox/evidence-inbox-view';

export const Route = createFileRoute('/inbox/')({
  staticData: {
    section: 'Quality',
    breadcrumb: 'Inbox',
    layout: 'full-height',
  },
  component: EvidenceInboxView,
});
